<template>
  <div class="is-main-content">
    <div class="columns is-fullheight">
      <b-collapse class="is-pulled-left is-sidebar-menu" :open="isOpen"
        v-bind:class="{'isCloseSidebar': !isOpen}">
        <aside class="menu">
          <app-filter/>
        </aside>
      </b-collapse>
      <a class="button collapse_btn" @click="isOpen = !isOpen">
        <b-icon class="icon_collapse"
          :icon="isOpen ? 'chevron-left' : 'chevron-right'">
        </b-icon>
      </a>
      <div class="column">
        <div>
          <div class="container is-fluid">
            <div class="columns">
              <div class="column is-9-fullhd is-7-desktop is-6-tablet">
                <div class="content">
                  <h3 class="">Vente Faces Unitaires</h3>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <br>
          <div class="container is-fluid">
            <div class="positionBntExport">
              <app-export-excel v-if="indexTab === 1" :liste="dataListe"/>
            </div>
            <div class="positionAzimut">
              <div class="is-pulled-left typeSelectionne">
                <b-checkbox
                  v-model="afficherAzimut"
                  @input="checkboxAzimut()">
                  Azimut
                </b-checkbox>
              </div>
            </div>
            <div class="is-pulled-right client">
              <app-client :disabled="true"/>
            </div>
            <div class="is-pulled-right">
              <div class="is-pulled-left typeSelectionne">
                <b-checkbox
                  v-model="showPanneauxSelectionne"
                  @input="checkboxFiltres()">
                  Faces sélectionnées
                </b-checkbox>
              </div>
            </div>
            <b-tabs type="is-toggle" v-model="indexTab" @input="autoZoom($event)">
              <b-tab-item :label="carteLibelle" icon="google-maps" id="ongletCarto">
                <app-carte v-if="showPanneaux && indexTab===0"
                ref="carto"/>
              </b-tab-item>
              <b-tab-item :label="listeLibelle" icon="format-list-bulleted">
                <app-liste v-on:liste="chargeListe($event)" v-if="showPanneaux"
                />
              </b-tab-item>
              <b-tab-item :label="planningLibelle" icon="calendar-text">
                <app-planning v-if="showPanneaux"/>
              </b-tab-item>
            </b-tabs>
            <div v-if="!showPanneaux">
              <div>
                <div class="hero">
                  <div class="section">
                    <div class="hero-body">
                      <h1 class="title is-1 has-text-centered">Commencer votre recherche</h1>
                      <div class="content">
                        <h3 class="has-text-centered">
                          Utilisez les filtres à gauche de l'écran pour effectuer votre recherche.
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-recharge
     :listeFaces="panneauxLcWithFilter"
     @recharge="recherchePanneauxLc()"/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/venteFacesLc-mutation-type';
import * as typesUser from '@/store/modules/user-mutation-type';
import * as sizesGetter from '@/services/general/sizeScreenGetter';
import gestionErreur from '@/services/general/gestionErreur';
import ExportExcel from '@/components/creationOpportunite/exportExcel';
import client from '../panier/client/client';
import Filter from './filtres/filtre';
import Liste from './recherche/liste';
import Carte from './recherche/carte';
import Planning from './recherche/planning';
import Recharge from './recharge';

const VenteFacesLc = createNamespacedHelpers('venteFacesLc');
const Panier = createNamespacedHelpers('panier');
const User = createNamespacedHelpers('user');
const VALEUR_FILTRE_SELECTED = 'selected';

export default {
  name: 'page',
  data() {
    return {
      isOpen: true,
      dataListe: [],
      indexTab: 0,
    };
  },
  components: {
    appFilter: Filter,
    appListe: Liste,
    appCarte: Carte,
    appPlanning: Planning,
    appClient: client,
    appExportExcel: ExportExcel,
    appRecharge: Recharge,
  },
  mounted() {
    const selected = this.panneauxLcWithFilter.filter((el) => { return el.selected; });
    this.setPointsAddress([]);
    if (this.address && this.rayon && (this.panneauxLcPanier.length !== selected.length)) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      this.actionsGestionPanneauxLc({ address: this.address,
        rayon: this.rayon,
        valid: true,
        panneauxLcPanier: this.panneauxLcPanier,
      }).then(() => {
        loadingComponent.close();
      }).catch((e) => {
        loadingComponent.close();
        gestionErreur('Erreur de la récupération des panneaux LC', e);
      });
    }
  },
  watch: {
    markers(val) {
      if (!val.length) this.setShowPanneaux(false);
    },
  },
  computed: {
    ...Panier.mapGetters({
      panneauxLcPanier: 'panneauxLcPanier',
    }),
    ...User.mapGetters({
      getAfficherAzimut: 'afficherAzimut',
    }),
    ...VenteFacesLc.mapGetters({
      panneauxLcWithFilter: 'panneauxLcWithFilter',
      showPanneaux: 'showPanneaux',
      getShowPanneauxSelectionne: 'showPanneauxSelectionne',
      address: 'address',
      rayon: 'rayon',
      markers: 'markers',
    }),
    showPanneauxSelectionne: {
      get() {
        return this.getShowPanneauxSelectionne;
      },
      set(value) {
        this.setShowPanneauxSelectionne(value);
      },
    },
    afficherAzimut: {
      get() {
        return this.getAfficherAzimut;
      },
      set(value) {
        this.setAfficherAzimut(value);
      },
    },
    carteLibelle() {
      return sizesGetter.isTablet() ? '' : 'Carte';
    },
    listeLibelle() {
      return sizesGetter.isTablet() ? '' : 'Liste';
    },
    planningLibelle() {
      return sizesGetter.isTablet() ? '' : 'Planning';
    },
  },
  methods: {
    ...VenteFacesLc.mapMutations({
      setAddFilterProperty: types.ADD_FILTER_PROPERTY,
      setShowPanneauxSelectionne: types.SET_SHOW_PANNEAUX_SELECTIONNE,
      setShowPanneaux: types.SET_SHOW_PANNEAUX,
      setPointsAddress: types.SET_POINTS_ADDRESS,
      setAdress: types.SET_FILTER_ADDRESS,
    }),
    ...User.mapMutations({
      setAfficherAzimut: typesUser.SET_AZIMUT,
    }),
    ...VenteFacesLc.mapActions({
      actionsGestionFiltres: 'gestionFiltres',
      actionsGestionPanneauxLc: 'gestionPanneauxLC',
      actionsUpdateMarkerPanneau: 'updateMarkerPanneau',
    }),
    checkboxFiltres() {
      const valeursFilter = [];
      if (this.showPanneauxSelectionne) {
        valeursFilter.push(this.showPanneauxSelectionne);
      } else {
        valeursFilter.splice(this.showPanneauxSelectionne, 1);
      }
      this.setAddFilterProperty(
        { property: VALEUR_FILTRE_SELECTED,
          valueProperty: {
            variable: VALEUR_FILTRE_SELECTED,
            valeur: valeursFilter,
            applicableEnfant: true,
          },
        });
      this.actionsGestionFiltres();
    },
    checkboxAzimut() {
      this.actionsUpdateMarkerPanneau();
    },
    chargeListe(data) {
      this.dataListe = data;
    },
    autoZoom(numIndexTab) {
      if (this.$refs.carto && numIndexTab === 0) {
        this.$refs.carto.autoZoom();
      }
    },
    recherchePanneauxLc() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      this.actionsGestionPanneauxLc({ address: this.address,
        codeFace: '',
        rayon: this.rayon,
        valid: true,
        panneauxLcPanier: this.panneauxLcPanier,
      }).then(() => {
        loadingComponent.close();
      }).catch((e) => {
        loadingComponent.close();
        gestionErreur('Erreur lors de la récupération des panneaux LC', e);
      });
    },
  },
  destroyed() {
    this.setPointsAddress([]);
    this.setAdress(null);
    this.setShowPanneaux(false);
  },
};
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteFacesLc/index.vue